var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"MappingSummaryChart",staticClass:"h-100",staticStyle:{"min-height":"400px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }